import { ApiBase } from '../ApiBase';
class CreatorChallengeDetailsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.findOngoingCreatorChallenge = () => {
            return this.get('/v1/creator/challenges');
        };
    }
}
export const CreatorMobilizationApiClient = new CreatorChallengeDetailsApiClientModel();
